import styled from 'styled-components';

export const Error = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;

  > div {
    > svg {
      margin-right: 5px;
    }
    padding: 5px 10px;
    width: 100%;
    background: rgb(150, 0, 0);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    font-size: 14px;
  }
`;

export const Confirmated = styled.div`

display: flex ;
align-items: center;
justify-content: center;
background: rgb(0,150,0) ;
margin: 15px auto;

border-radius: 15px;
padding: 15px;
width: 100% ;
max-width: 400px;


>svg{ width: 30px; margin: 10px; color: #fff; min-width: 30px; height: 30px}

>h3{
  font-size: 16px;
  color: #fff;
  text-align: left;
  width: 100%;
}

`;